import React, { Component } from 'react'
import Link from 'gatsby-link'
import gql from 'graphql-tag'
import { graphql, withApollo } from 'react-apollo'

const query = gql`
  query {
      allInventories {
          id
          year
          make
          model
          mileage
          stockNo
      }
  }
`;

const inventorySubscription = gql`
    subscription  {
        Inventory {
            mutation # contains CREATED, UPDATED or DELETED
            node {
                id
                year
                make
                model
                mileage
                stockNo
            }
        }
    }  
  
`

class IndexPage extends Component {
  componentDidMount() {
    this.props.subscribeToInventory();
  }
  render() {
    const { data, client } = this.props;
    console.log('ppprops', this.props,data.allInventories);
    console.log('client', client.reduxRootKey, client.store.getState())
    return (
        <div>
          {typeof data.allInventories === 'undefined' ? <div>Loading...</div> : <Vehicles vehicles={data.allInventories} />}
        </div>
    )
  }
}


const Vehicles = ({ vehicles }) =>
  <div>
    {vehicles.map(vehicle => <VehicleCard key={vehicle.id} vehicle={vehicle} />)}
  </div>;

const VehicleCard = ({ vehicle }) => (
    <div style={{ width: '400px', padding: '2em 1em' }}>
      <img src={`http://www.wheelkinetics.com/ebay/${vehicle.stockNo}/image1.jpg`} style={{ float: 'left', width: '100px', height: 'auto', paddingRight: '1em' }}/>
      <div><HtmlLink link={`${vehicle.make}-${vehicle.stockNo}`}>{`${vehicle.year} ${vehicle.make} ${vehicle.model}`}</HtmlLink></div>
      <div>{vehicle.mileage} mi</div>
    </div>
)

const HtmlLink = ({ link, children }) =>
  <div><Link to={`/${link}/`}>{children}</Link></div>

const apolloOptions = {
  options: {
    fetchPolicy: 'cache-and-network'
  },
  props: props => {
    return {
      data: props.data,
      subscribeToInventory: params => {
       // console.log('p', props);
        return props.data.subscribeToMore({
          document: inventorySubscription,
          updateQuery: (prev, { subscriptionData }) => {
           // console.log('update query', subscriptionData);
            if (!subscriptionData.data) {
              return prev;
            }
            const newInventory = subscriptionData.data.Inventory.node;
            return Object.assign({}, prev, {
              entry: {
                Inventory: [newInventory, ...prev.entry.comments]
              }
            })
          }
        })
      }
    }
  }
}
export default withApollo(graphql(query, apolloOptions)(IndexPage));



// WEBPACK FOOTER //
// ./src/pages/index.js